import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";

export function FloatingQuote({ threshold = 650 }) {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > threshold);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, [threshold]);

  return (
    <AnimatePresence>
      {show && (
        <motion.aside
          initial={{ opacity: 0, x: 40 }}
          animate={{ opacity: 1, x: 0 }}
          exit={{ opacity: 0, x: 40 }}
          transition={{ duration: 0.45 }}
          className="fixed right-3 bottom-3 md:right-6 md:bottom-6 z-[95] w-[210px] md:w-[300px]"
          data-testid="floating-quote"
        >
          <div className="dk-panel quote-banner rounded-2xl border-2 px-4 py-3.5 md:px-6 md:py-5 relative overflow-hidden" style={{ borderColor: "rgba(240,161,60,0.45)" }}>
            <div className="absolute -top-10 -right-10 w-28 h-28 rounded-full blur-3xl opacity-25" style={{ background: "#F0A13C" }} />
            <div className="relative">
              <span className="text-c-amber text-sm md:text-base leading-none animate-pulse">✦</span>
              <p className="quote-shimmer font-display italic font-medium text-[11px] md:text-sm leading-snug tracking-tight mt-1.5 md:mt-2">
                “Just as temples, churches, mosques, and synagogues are sacred places for worship, laboratories are the sacred places where science and mathematics are truly learned, explored, and discovered.”
              </p>
            </div>
          </div>
        </motion.aside>
      )}
    </AnimatePresence>
  );
}
